/* eslint-disable */
import { node, icon, text } from "~/util/dom";
import { CONFIG, getUserwebConfigData, removeUserwebConfigData, setUserwebConfigData } from "~/config";
import ContentOverlay from "~/content.overlay";
import { setItem, removeItem, getItem } from "~/util/cookies";

export default function UserwebConfig(pub: boolean = false) {
	return class extends ContentOverlay {
		_rqs: Array<any>;
		_configItem: any;
		_conf: any;
		_actualConf: any;
		_pub: boolean;

		constructor() {
			super();

			this._contentName = "userweb-config";
			this._rqs = [];
			this._configItem = {};
			this._conf = null;
			this._actualConf = null;
			this._pub = pub;
			this._dom = {
				container: node("div", { className: "userweb-config" }),
			};

			this._buildCloseButton();

			this._load();
		}

		destroy() {}

		show() {
			Mapy.getComponent("layout").setWidth(1);

			return super.show();
		}

		handleEvent(e) {
			if (e.target.classList.contains("save") || e.target.closest("button.save")) {
				this._save();
				location.reload();
			}
			else if (e.target.classList.contains("close") || e.target.closest("button.close") || e.target.classList.contains("back") || e.target.closest("button.back")) {
				this.deactivate();
			}
			else if (e.target.classList.contains("reset") || e.target.closest("button.reset")) {
				this._reset();
				location.reload();
			}
		}

		_load() {
			Mapy.Util.request(CONFIG.requestUrl + "/userwebConf", { type: "json" }).promise.then(data => {
				let saveData = null;
				const storage = getUserwebConfigData();

				this._conf = data.data;

				if (storage) {
					saveData = structuredClone(this._conf);

					for (let section in storage) {
						if (this._conf[section]) {
							saveData[section] = {};

							for (let item in storage[section]) {
								if (this._conf[section][item]) {
									saveData[section][item] = Object.assign({}, this._conf[section][item]);
									saveData[section][item].def = saveData[section][item].default;
									saveData[section][item].default = storage[section][item];
								}
							}
						}
					}
				} else {
					if (CONFIG.isEditorial && this._conf?.editorial?.interface) {
						this._conf.editorial.interface.default = 1;
					}
				}

				this._build(saveData || this._conf);
			}, () => {});
		}

		_build(conf:any) {
			this._dom.container.innerHTML = "";

			const closeBtn = node("button", { type: "button", className: "close" });
			closeBtn.classList.add("close");
			closeBtn.append(icon("close"));

			closeBtn.addEventListener("click", this);

			this._dom.container.append(closeBtn);

			for (let section in conf) {
				this._buildSection(section);

				this._configItem[section] = {};

				for (let item in conf[section]) {
					this._configItem[section][item] = this._buildItem(conf, section, item);
				}
			}

			// wasm
			const isWasmCookieSet = getItem(CONFIG.wasmCookie) === "1";

			if (isWasmCookieSet) {
				const title = node("h3", { className: "section", textContent: "WASM" });
				const closeWasm = node("button", { type: "button", className: "save" }, "Vypnout");

				title.style.marginBottom = "20px";
				closeWasm.addEventListener("click", () => {
					removeUserwebConfigData();
					removeItem(CONFIG.wasmCookie);
					location.reload();
				});
				this._dom.container.append(title, closeWasm);
			}

			const buttons = node("div", { className: "buttons" });
			const btn = node("button", { type: "button", className: "save" }, "Uložit");
			const clear = node("button", { type: "button", className: "reset" }, "Resetovat");
			const close = node("button", { type: "button", className: "back" }, "Zavřít");

			buttons.addEventListener("click", this);

			buttons.append(btn, clear, close);

			this._dom.container.append(buttons);

			this._actualConf = structuredClone(conf);
		}

		_buildSection(section:any) {
			let title = node("h3", { className: "section"}, section);

			this._dom.container.appendChild(title);
		}

		_buildItem(conf: any, section: string, name: string) {
			const item = conf[section][name];
			let con = node("div", { className: "item" });
			let label: HTMLLabelElement | HTMLParagraphElement = node("label");
			let input = null;

			switch (item.type) {
				case "checkbox":
					label.classList.add("switch");
					input = node("input", { type: "checkbox", value: "default", checked: !!item.default });
					const span = node("span", { className: "slider" });
					label.append(input, span, item.label, this._pub ? `` : node("small", {}, `<def: ${item.def ? "on" : "off"}>`));

					if (item.parent) {
						input.addEventListener("input", () => {
							this._checkedParent(section, item.parent, input.checked);
						});
					}
					break;

				case "radio":
					label = node("p", { className: "radio-cont" });
					label.append(node("span", { className: "text" }, item.label));
					item.values.forEach(radio => {
						const itemLabel = node("label", { className: "radio" });
						const inputRadio = node("input", { type: "radio", name: name, value: radio.value, checked: radio.value === item.default });

						itemLabel.append(inputRadio, text(radio.label));
						label.append(itemLabel);
					});
					label.append(this._pub ? `` : node("small", {}, `<def: ${item.def ? "on" : "off"}>`));

					input = label;
					break;

				case "text":
					label.append(node("span", { className: "text" }, item.label));
					input = node("input", { type: "text", value: item.default });
					label.append(input, this._pub ? ``: node("small", {}, `<def: ${item.def}>`));
					break;
			}

			con.append(label);
			this._dom.container.append(con);

			return {
				input
			}
		}

		_save() {
			let saveData: any = {};

			for (let section in this._actualConf) {
				saveData[section] = {};

				for (let item in this._actualConf[section]) {
					switch (this._actualConf[section][item].type) {
						case "checkbox":
							this._actualConf[section][item].default = this._configItem[section][item].input.checked ? 1 : 0;
							saveData[section][item] = this._actualConf[section][item].default;

							if (this._actualConf[section][item].cookie) {
								saveData[section][item] ? setItem(this._actualConf[section][item].cookie, saveData[section][item]) : removeItem(this._actualConf[section][item].cookie);
							}

							break;

						case "radio":
							this._actualConf[section][item].default = this._configItem[section][item].input.querySelector("input:checked").value;
							saveData[section][item] = this._actualConf[section][item].default;

							if (this._actualConf[section][item].cookie) {
								saveData[section][item] !== this._actualConf[section][item].default ? setItem(this._actualConf[section][item].cookie, saveData[section][item]) : removeItem(this._actualConf[section][item].cookie);
							}

							break;

						case "text":
							let val = this._configItem[section][item].input.value;

							if (this._conf[section][item].min && this._conf[section][item].min > parseInt(val)) {
								val = this._conf[section][item].min;
							}

							this._actualConf[section][item].default = val;
							saveData[section][item] = this._actualConf[section][item].default;
							break;
					}
				}
			}

			try {
				setUserwebConfigData(saveData);
			} catch(ex) {}
		}

		_checkedParent(section: string, parentName: string, checked: boolean) {
			if (this._configItem && section && this._configItem[section] && parentName && this._configItem[section][parentName]) {
				if (checked && !this._configItem[section][parentName].input.checked) {
					this._configItem[section][parentName].input.checked = true;
				}
			}
		}

		_reset() {
			removeUserwebConfigData();

			for (let section in this._actualConf) {
				for (let item in this._actualConf[section]) {
					if (this._actualConf[section][item].cookie){
						removeItem(this._actualConf[section][item].cookie);
					}
				}
			}

			this._build(this._conf);
		}
	};
}
